module.exports = __webpack_public_path__ + "static/media/NE.fc49f07b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NE.svg
// module id = 327
// module chunks = 0